import { Popconfirm, Tooltip } from "antd";
import { isEmpty } from "lodash";
import { useToast } from "modules/navbar/top/store/toasterStore";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { usePrescription, useSendToDispatch } from "./store";

function SendToDispatch({ order, buttonText, prescriptionsData }) {
  const { id } = useParams();
  const { setToaster } = useToast();
  const { setSendToDispatch } = useSendToDispatch();
  const hasPrescription = (prescriptionsData) => {
    return isEmpty(prescriptionsData)
      ? false
      : (Array.isArray(prescriptionsData)&& prescriptionsData?.length)
      ? prescriptionsData?.some(
          (prescription) => prescription?.order_id === order?.id
        )
      : false;
  };

  const disableSendToDispatch =
    order.status === "delivered" ||
    order.status === "shipping_pending" ||
    order.status === "shipped" ||
    order.status === "void" ||
    !hasPrescription(prescriptionsData);
  const handleConfirm = () => {
    setSendToDispatch(order?.id, setToaster);
  };

  return (
    <div>
      <Tooltip title="Send To Dispatch">
        {!disableSendToDispatch ? (
          <Popconfirm
            style={{ width: "5rem" }}
            disabled={disableSendToDispatch}
            title={
              <span>
                Are you sure you want to mark this order for shipping? <br />
                Note: This will cause the order to be sent to dispatch.
              </span>
            }
            placement="topLeft"
            onConfirm={handleConfirm}
          >
            <span
              className={`mt-n1 bg-primary text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
              id="send-to-dispatch"
            >
              {buttonText}
            </span>
          </Popconfirm>
        ) : (
          <span
            className={`mt-n1 bg-primary disabled-action text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
          >
            {buttonText}
          </span>
        )}
      </Tooltip>
    </div>
  );
}

export default SendToDispatch;
